import { render, staticRenderFns } from "./RegisterPanel.vue?vue&type=template&id=4771e032&scoped=true&"
import script from "./RegisterPanel.vue?vue&type=script&lang=js&"
export * from "./RegisterPanel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPanel.vue?vue&type=style&index=0&id=4771e032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771e032",
  null
  
)

export default component.exports